import { DATE_TIME_CHANGE_EVENT, VAT_INCLUSIVITY_CHANGE_EVENT, COUPON_CHANGE_EVENT, CONTEXT_CHANGE_EVENT, INITIALIZED_EVENT, SCRIPT_LOADED_EVENT } from './shared-constants.js';

const fireEvent = function(eventName, payload) {
  if (typeof document === "undefined") {
    return;
  }
  const event = new CustomEvent(eventName, { detail: payload });
  document.dispatchEvent(event);
};
const EVENTS = {
  SCRIPT_LOADED_EVENT,
  INITIALIZED_EVENT,
  CONTEXT_CHANGE_EVENT,
  COUPON_CHANGE_EVENT,
  VAT_INCLUSIVITY_CHANGE_EVENT,
  DATE_TIME_CHANGE_EVENT
};

export { EVENTS, fireEvent };
//# sourceMappingURL=web-events.js.map
